import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {SipProvider} from '../../../providers/sip/sip';
import {ViewController} from '../../../providers/view-controller.service';
import {CallViewPageComponent} from '../call-view/call-view';
import {ModalService} from '../../../providers/modal.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-page-incomming-call',
  templateUrl: 'incomming-call.html',
  styleUrls: ['./incomming-call.scss']
})
export class IncommingCallPageComponent implements OnInit, OnDestroy {

  @Input() callerName = 'Unbekannt';
  private onUpdateUI: Subscription;

  constructor(public modalCtrl: ModalService,
              public viewCtrl: ViewController,
              private sipProvider: SipProvider) {
  }

  ngOnInit() {
    const incommingUpdateUI = (session) => {
      if (!session) {
        this.viewCtrl.dismiss();
      }
    };

    this.onUpdateUI = this.sipProvider.events.subscribe('onUpdateUI', incommingUpdateUI);

  }

  ngOnDestroy() {
    this.onUpdateUI.unsubscribe();
  }

  acceptCall() {
    this.viewCtrl.dismiss().then(async () => {
      await this.modalCtrl.openModal(CallViewPageComponent, {callName: this.callerName});
      this.sipProvider.answer();
    }).catch((error) => {
      console.error(error);
    });
  }

  cancelCall() {
    this.sipProvider.hangUp();
    this.viewCtrl.dismiss().catch((error) => {
      console.error(error);
    });
  }
}
